import React, { useState } from 'react'
import styled from 'styled-components'
import { Status } from '../../../../interfaces/status';
import { ajaxFetcherGet } from '../../../../fetchers';
import { useTranslation } from 'react-i18next';

interface Props {
    onChange?: (status:Status) => void;
    value?: Status;
    id?: BigInteger;
    requestsHotelsPriority?: string;
    request_type_slug?: string

}

const Button = styled.button`
  height: 30px;
  width: 30px;
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
  font-size: .9rem!important;
  border-radius: 0.38rem !important;
  background-color:#F0F0F0!important;
  
  &.btn-low{
    background-color:#83A3A9!important;
    color:white!important;
  }

  &.btn-high{
    background-color:#DC3545!important;
    color:white!important;
  }

  &.btn-medium{
    background-color:#FFBB33!important;
    color:white!important;
  }

  i {
    font-size: .9rem;
    margin: 0;
  }

  .btn-option-sm {
    height: 25px;
    width: 25px;
    font-size: .7rem;

    i {
      font-size: .7rem;
    }
  }
`;

const PriorityDropdown = styled.div`

  .dropdown-item {
    cursor: pointer;
  }

  .dropdown-item:not(.hover-no-priority):hover {
    color:white;
    cursor: pointer;
  }

  .dropdown-item.hover-high:hover{
    background-color:#DC3545;
    color:white!important;
  }

  .dropdown-item.hover-medium:hover{
    background-color:#FFBB33;
    color:white!important;
  }

  .dropdown-item.hover-low:hover{
    background-color:#83A3A9;
    color:white!important;
  }

`;

export default function ButtonPriorityDropdown(props:Props){
	const { 
    onChange,
    id,
    value = '',
    request_type_slug = 'accommodation'
	} = props

  const { t: gctrad } = useTranslation();

  const [priorityList, setPriorityList] = useState<Status[]>([]);
  
  const onClick = () => {
    ajaxFetcherGet({
      url: `${ENV.base_lang_url}myspace/providers//ajaxGetter/get_status_by_type/priority`,
  }).then((res: Status[]) => {
    res.push({
      slug: 'no-priority',
      key_trad: 'no-priority',
      level: 10,
      title: gctrad('Aucune priorité')
    });
    res.sort((a,b) => b.level - a.level);
    setPriorityList(res);
  })
  }

	return (
    <div className="btn-group">
      <Button 
        type="button"
        className={`btn btn-option btn-priority text-gc-dark-blue small mr-2 default btn-`+value}
        data-toggle="dropdown" 
        aria-haspopup="true" 
        aria-expanded="false"
        onClick={onClick}
        data-priority-button-id={id}
      >
        {request_type_slug == 'accommodation' ? 
          <i className="fa-regular fa-folder"></i>
          :
          <i className="fa-regular fa-folder-tree"></i>
        }
      </Button>
      <PriorityDropdown>
      <div className="dropdown-menu dropdown-menu-left text-gc-dark-blue p-0">
        {
          priorityList.map((priority, i) => {
            return (
              <a 
                key={i}
                className={"dropdown-item small hover-"+priority.slug}
                onClick={() => onChange(priority)}
                /*href='#'
                data-target={e.href}
                data-part='+'
                data-id={e.dataId}
                onClick={e.onClick ?? (() => null)}*/
              >
                {priority.title}
              </a>
            )
          })
        }
      </div>
      </PriorityDropdown>
    </div>
	);
}